import React, { useEffect } from 'react';
import {decodeEntities} from '@wordpress/html-entities';
import DOMPurify from "dompurify";
import {  CheckoutButton } from '.';

const { registerPaymentMethod } = window.wc.wcBlocksRegistry
const { getSetting } = window.wc.wcSettings

const settings = getSetting( 'spgw_ideal_data', {} );

const { title, save_card_html, icon, description, bankdetails } = settings;
const label = decodeEntities( settings.title || '' );
const desc =  DOMPurify.sanitize(description);
const cleanHTML = DOMPurify.sanitize(save_card_html);
const bank = DOMPurify.sanitize(bankdetails);

const bankComponent = (props) => {
	const { onPaymentSetup,emitResponse } = props;
	useEffect(() => {
	  const unsubscribe = onPaymentSetup(async () => {
		// Here we can do any processing we need, and then emit a response.
		// For example, we might validate a custom field, or perform an AJAX request, and then emit a response indicating it is valid or not.
		const fromCheckoutBlock = "yes";
		
		const paymentType = document.querySelector(
		  "[name^='idealpreselect']"
		);
		let paymentBank = "";
	   
		const payloads =  {
		  
		  fromCheckoutBlock, 
		}
		if (paymentType){
  
			paymentBank = `${paymentType.value}`;
		  payloads.paymentBank = paymentBank;
		}
  
		
		return {
		  type: emitResponse.responseTypes.SUCCESS,
		  meta: {
			paymentMethodData: payloads
		  },
		};
  
	  });
	  // Unsubscribes when this component is unmounted.
	  return () => {
		unsubscribe();
	  };
	}, [
	  emitResponse.responseTypes.ERROR,
	  emitResponse.responseTypes.SUCCESS,
	  onPaymentSetup,
	]);
  }

const ContentComponent = (props) => {
	const { eventRegistration, emitResponse } = props;
 	 const { onPaymentSetup } = eventRegistration;
	return <div><div dangerouslySetInnerHTML={{ __html: desc }} /><div dangerouslySetInnerHTML={{ __html: bank }} />
	<bankComponent onPaymentSetup={onPaymentSetup} emitResponse={emitResponse} /><CheckoutButton />
	<div dangerouslySetInnerHTML={{ __html: cleanHTML }} /></div>;
  };
const Icon = () => {
	return icon 
		? <img alt='' src={icon} style={{ float: 'right', marginRight: '20px' }} /> 
		: '';
};
const Label = () => {
	return (
		<span style={{ width: '100%' }}>
			{title}
			<Icon />
		</span>
	);
};


registerPaymentMethod( {
	name: "spgw_ideal",
	label: <Label />,
	content: <ContentComponent/>,
	edit: <ContentComponent />,
	canMakePayment: (cart) => {
		if(!settings.availability) {
			return false;
		}
		if(cart.billingAddress.country == "" || (settings.allowedCountries.length == 1 && settings.allowedCountries.includes('select'))) {
			return true;
		}
		if(settings.allowedCountries.length != 0) {
			return settings.allowedCountries.includes(cart.billingAddress.country);
		}
		return true;
	},
	ariaLabel: label,
	supports: {
		features: settings.supports,
		showSavedCards: false,
		showSaveOption: false,

	}
} )

